import React, { useState, useEffect } from "react";
import { Form, Row, Col } from "react-bootstrap";

const RatioTextField = (props) => {
  const [numerator, setNumerator] = useState("");
  const [denominator, setDenominator] = useState("");

  const handleNumeratorChange = (event) => {
    const onlydigitsValue = event.target.value.replace(/[^0-9]/g, "");
    setNumerator(onlydigitsValue);
    let result = onlydigitsValue + `:${denominator}`;
    props.onChange(result);
  };

  const handleDenominatorChange = (event) => {
    const onlydigitsValue = event.target.value.replace(/[^0-9]/g, "");
    setDenominator(onlydigitsValue);
    let result = `${numerator}:` + onlydigitsValue;
    props.onChange(result);
  };

  useEffect(() => {
    if(props.value !=null){
    const [a, b] = props.value.split(":");
    setNumerator(a ? a : "");
    setDenominator(b ? b : "");
  }
  }, [props.value]);

  return (
    <>
      <Row>
        <Col>
          <Form.Control
            required={props.required}
            className="ratioNumeratorCellInput"
            type="text"
            value={numerator}
            onChange={handleNumeratorChange}
            placeholder="Num"
          />
        </Col>
        <Col className="noSpace">
          <span className="ratioText">:</span>
        </Col>
        <Col>
          <Form.Control
            required={props.required}
            className="ratioDenominatorCellInput"
            type="text"
            value={denominator}
            onChange={handleDenominatorChange}
            placeholder="Den"
          />
        </Col>
      </Row>
    </>
  );
};

export default RatioTextField;
